var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"app"}},[_c('div',{staticClass:"left"},[_c('SideBar',{attrs:{"id":"sidebar"}})],1),_c('div',{staticClass:"right"},[_c('router-view',{attrs:{"id":"main","photos":_vm.photos}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }